import { render, staticRenderFns } from "./VideoPanorama.vue?vue&type=template&id=4addaef7&scoped=true&"
import script from "./VideoPanorama.vue?vue&type=script&lang=js&"
export * from "./VideoPanorama.vue?vue&type=script&lang=js&"
import style0 from "./VideoPanorama.vue?vue&type=style&index=0&id=4addaef7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addaef7",
  null
  
)

export default component.exports